import "./polyfills";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App";
import { AltheiaWalletProvider } from "./components/providers/WalletProvider";
import { AltheiaAuthProvider } from "./components/providers/AuthProvider";
import { SuiProviders } from "./components/providers/SuiProviders";

import "./styles/tokens.css";
import "./styles/dashboard.css";
import "./styles/landing.css";
import "./styles/brand.css";

// Theme bootstrap: applied synchronously before React renders to avoid a
// light-mode flash for users who saved a dark preference. Settings page
// writes "altheia-theme" on toggle.
try {
  if (localStorage.getItem("altheia-theme") === "dark") {
    document.documentElement.setAttribute("data-theme", "dark");
  }
} catch { /* localStorage may be blocked; safe to ignore */ }

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("missing #root");

createRoot(rootEl).render(
  <StrictMode>
    <BrowserRouter>
      <SuiProviders>
        <AltheiaWalletProvider>
          <AltheiaAuthProvider>
            <App />
          </AltheiaAuthProvider>
        </AltheiaWalletProvider>
      </SuiProviders>
    </BrowserRouter>
  </StrictMode>,
);
